interface ProgressBarProps {
  value: number;
  max: number;
  tone?: 'primary' | 'accent' | 'secondary';
  className?: string;
}

const TONE_CLASSES = {
  primary: 'bg-primary-500',
  accent: 'bg-accent-500',
  secondary: 'bg-secondary-500',
};

export default function ProgressBar({ value, max, tone = 'primary', className = '' }: ProgressBarProps) {
  const safeMax = max > 0 ? max : 1;
  const percent = Math.min(100, Math.max(0, Math.round((value / safeMax) * 100)));
  return (
    <div
      className={`h-2 w-full overflow-hidden rounded-full bg-background-200 ${className}`}
      role="progressbar"
      aria-valuenow={value}
      aria-valuemin={0}
      aria-valuemax={safeMax}
    >
      <div
        className={`h-full rounded-full transition-all duration-300 ${TONE_CLASSES[tone]}`}
        style={{ width: `${percent}%` }}
      />
    </div>
  );
}